"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 7.7A4.7 4.7 0 0 1 7.7 3h8.6A4.7 4.7 0 0 1 21 7.7v8.6a4.7 4.7 0 0 1-4.7 4.7H7.7A4.7 4.7 0 0 1 3 16.3zm4.7-3.3a3.3 3.3 0 0 0-3.3 3.3v8.6a3.3 3.3 0 0 0 3.3 3.3h8.6a3.3 3.3 0 0 0 3.3-3.3V7.7a3.3 3.3 0 0 0-3.3-3.3z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.442 14.182c-1.37.321-2.483.79-3.206 1.366l-.872-1.096c.951-.757 2.29-1.288 3.758-1.633 1.48-.348 3.149-.519 4.808-.519s3.327.17 4.807.518c1.47.345 2.808.877 3.759 1.635l-.872 1.095c-.723-.576-1.836-1.045-3.207-1.367-1.359-.319-2.918-.481-4.487-.481-1.57 0-3.129.163-4.488.482",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.56 8.6a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ImageIcon24.js.map